/* global window */
export default function (images) {
  if (typeof window === 'undefined') {
    return
  }
  images.forEach(image => {
    let img = new window.Image()
    img.src = image
  })
}
